import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0a62774c")

_pushScopeId("data-v-0a62774c")
const _hoisted_1 = {
  class: "pantry-select-category",
  id: "selectCategoryComponentTop"
}
const _hoisted_2 = { class: "pantry-select-category-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_PantrySelectCategoryItem = _resolveComponent("PantrySelectCategoryItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categoryArray, (category) => {
        return (_openBlock(), _createBlock(_component_PantrySelectCategoryItem, {
          class: "pantry-select-category-item",
          key: category.index,
          index: category.index,
          categoryName: category.categoryName,
          isSelect: category.isSelect,
          onOnClick: _ctx.selectCategory
        }, null, 8, ["index", "categoryName", "isSelect", "onOnClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})